export const emailConfig = {
  twoFactorAuthErrorEmail: {
    templateName: 'twoFactorAuthErrorEmail',
    fromEmailAddress: 'twofactorauthfailure@havenlife.com',
    emailSubject: 'Important: - 2 Factor Auth Down - Coverpath Client Unable to Create Account',
    emailBody:
      '<p>Coverpath user is unable to create an account on Coverpath because they are unable to receive a verification code. Please check the status of the Two Factor Authentication services.</p>',
    fromEmail: 'no-reply@massmutual.com',
    fromName: 'MassMutual Convertible Automatic Email',
  },
};
